<template>
  <div id="app" :style="gridTemplateColumns">
    <Header title="LC Base de conhecimento" :hideUserDropdown="!user" />
    <Menu />
    <Content />
  </div>
</template>

<script>
import { userKey } from "@/global";
import { mapState } from "vuex";
import Header from "./components/template/Header.vue";
import Menu from "./components/template/Menu.vue";
import Content from "./components/template/Content.vue";

export default {
  name: "App",
  components: { Header, Menu, Content },
  computed: {
    ...mapState(["user"]),
    styleFooter() {
      return this.$route.name === "/login" ? "height: 0" : "";
    },
    gridTemplateColumns() {
      if (this.$mq === "xs" || this.$mq === "sm") {
        this.$store.commit("toggleMenu", false);
        return "grid-template-rows: 100px 1fr";
      }

      return "";
    },
  },
  created() {
    const json = sessionStorage.getItem(userKey);
    if (json !== null) {
      // const sessionExpired = sessionStorage.getItem("sessionExpired");
      // if (sessionExpired) {
      //   showError({
      //     response: {
      //       data: {
      //         message: "Sessão expirada",
      //       },
      //     },
      //   });
      //   const user = JSON.parse(sessionStorage.getItem("loginPassword"));
      //   axios
      //     .post(`${baseApiUrl}/autenticacao/login`, user)
      //     .then((res) => {
      //       console.log("Sessão atualizada!");
      //       this.$store.commit("setUser", res.data);
      //       sessionStorage.setItem(userKey, JSON.stringify(res.data));
      //       this.$toasted.global.defaultSuccess({ msg: "Sessão atualizada" });
      //       sessionStorage.removeItem("sessionExpired");
      //     })
      //     .catch((res) => showError(res));
      //   sessionStorage.removeItem(userKey);
      //   this.$store.commit("setUser", null);
      //   return this.$router.push({ name: "login" });
      // }

      const json = sessionStorage.getItem(userKey);
      const userData = JSON.parse(json);
      this.$store.commit("setUser", userData);
      if (this.$mq === "xs" || this.$mq === "sm") {
        this.$store.commit("toggleMenu", false);
      }
    }
  },
};
</script>

<style>

* {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}

body {
  margin: 0;
}

tbody th {
  font-weight: normal;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: 100vh;
  display: grid;
  grid-template-rows: min-content 1fr;
  grid-template-columns: min-content 1fr;
  grid-template-areas:
    "header header"
    "menu content";
}
</style>